import errorManager from '@/rollbar.js';

const setListener = (input_cell, ul_selector) => {
  if (!input_cell) return;

  input_cell.addEventListener('input', (event) => {
    const searchTerm = event.target.value.toLowerCase();
    const items = ul_selector.querySelectorAll('li');
    if (!items.length) return;

    items.forEach((item) => {
      const text = item.textContent.toLowerCase();
      item.style.display = text.includes(searchTerm) ? 'list-item' : 'none';
    });
  });
};

const init = (input_selector, ul_selector) => {
  try {
    setListener(input_selector, ul_selector);
  } catch (e) {
    errorManager(e);
  }
};

window.UlFilter = {
  init: init,
};
